import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({
  booking_provider: "skedda",
  booking_skedda_url: "https://spikesportscanada.skedda.com/",
  loading: true,
  refresh: async () => {},
});

const FALLBACK = {
  booking_provider: "skedda",
  booking_skedda_url: "https://spikesportscanada.skedda.com/",
  show_membership: false,
  show_inhouse_booking: false,
  show_shop: false,
  shop_iframe_url: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings({ ...FALLBACK, ...data });
    } catch {
      setSettings(FALLBACK);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ ...settings, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

/**
 * Resolves the right click handler / href for any "Book a Lane" CTA.
 * - provider "skedda"  -> opens external Skedda URL in a new tab
 * - provider "iframe"  -> internal route /book (renders Skedda iframe)
 * - provider "inhouse" -> internal route /book (original in-house flow)
 */
export const useBookLink = () => {
  const { booking_provider, booking_skedda_url } = useSettings();
  if (booking_provider === "skedda") {
    return {
      href: booking_skedda_url,
      external: true,
      target: "_blank",
      rel: "noopener noreferrer",
      to: null,
    };
  }
  return { href: null, to: "/book", external: false, target: null, rel: null };
};
